import React from 'react'
import './footer.scss'

function Footer() {
  return (
    <footer className='main-footer'>
        <div className='social-links'>
          <a href='https://www.linkedin.com/in/aprameya-shankar-44523a239/' rel='noreferer' name="LinkedIn">
              <span className='block-anim'>LinkedIn</span>
          </a>
          <a href='https://github.com/Aprameya-S' rel='noreferer' name="Github">
              <span className='block-anim'>Github</span>
          </a>
          <a href='mailto:aprameyashankar@gmail.com' rel='noreferer' name="Email">
              <span className='block-anim'>Email</span>
          </a>
        </div>
        <span className='copyright'>© {new Date().getFullYear()} Aprameya Shankar</span>
    </footer>
  )
}

export default Footer